const ListMixin = {
  data(){
    return {
      pagesize:10,
      currentPage:1,
      pageTotal:10,
      vloading:false
    }
  },
  created(){
    this.resetCurrentPage()
  },
  methods:{
    resetCurrentPage(){
      this.currentPage = 1
      this.ajaxLoadTable()
    },
    handleCurrentChange(v){
      this.currentPage = v
      this.ajaxLoadTable()
    }
  }
}

export {
  ListMixin
}


// WEBPACK FOOTER //
// ./src/utils/mixins.js